import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import CompanySubnav from './CompanySubnav';
import { useCompanyReveal } from './useCompanyReveal';
import './companyShared.scss';
import './Company.scss';

const STATS = [
  { num: '120', suffix: '+', label: '도입 교회' },
  { num: '12', label: '팀 멤버' },
  { num: '2023', label: '설립 연도' },
  { num: '96%', label: '재계약률' },
];

const VALUES = [
  {
    num: '01',
    title: '정직',
    desc: '숨김 없는 요금, 투명한 계약. 말하지 않은 비용은 없습니다.',
  },
  {
    num: '02',
    title: '섬김',
    desc: '교회와 성도를 위한 도구를 만듭니다. 기술이 주인이 아닙니다.',
  },
  {
    num: '03',
    title: '단정',
    desc: '화려한 기능보다, 매주 쓰는 기능이 더 편하고 잘 보이게.',
  },
];

const HISTORY = [
  { year: '2023', title: '교회앱모아 설립', desc: '서울, 교회 전용 앱 제작 스타트업으로 시작.' },
  { year: '2024', title: '50교회 도입', desc: '온라인주보 · 교회소식 핵심 서비스 정립.' },
  { year: '2025', title: '100교회 돌파', desc: '출석부 · 재정관리 등 교회 운영 기능 확장.' },
  { year: '2026', title: '120+ 교회 파트너', desc: '전국 교단 · 개척교회까지 폭넓은 도입.' },
];

const TEAM = [
  {
    initial: 'H',
    name: '김하나',
    role: '대표 · Founder',
    desc: '교회에서 자란 개발자. 교회의 운영과 신앙을 잇는 가장 단정한 도구를 만들고 싶습니다.',
  },
  {
    initial: 'Y',
    name: '이요한',
    role: '도입 컨설턴트',
    desc: '교회 규모와 성향에 맞춰 최적의 서비스 조합을 함께 설계합니다.',
  },
  {
    initial: 'S',
    name: '박소망',
    role: '기술 지원',
    desc: '서비스 이용 중 발생하는 모든 기술 문의에 빠르게 응답합니다.',
  },
];

const PARTNERS = [
  '은혜교회',
  '새생명교회',
  '평강교회',
  '사랑의교회',
  '동산교회',
  '소망교회',
];

export default function Company() {
  useCompanyReveal();

  return (
    <div className="company-page company-about">
      <Header />
      <CompanySubnav />

      <section className="page-header">
        <div className="container reveal">
          <div className="breadcrumb">
            <Link to="/">Home</Link> <span>· Company</span>
          </div>
          <div className="page-header-grid">
            <div>
              <h1 className="page-title">
                교회를 위한 앱,
                <br />
                <span className="em">진심으로</span>.
              </h1>
              <p className="page-sub">
                15년 교회 사역 경력의 목사가 대표로 있는, 교회 전용 앱 제작 스타트업입니다. 개발자, 디자이너,
                실제 교회에서 사역해본 팀원들이 함께 일합니다.
              </p>
            </div>
            {/* <div className="page-meta">Est. 2026</div> */}
          </div>
        </div>
      </section>

      {/* <section className="about-stats reveal">
        <div className="stats-inner">
          {STATS.map((stat) => (
            <div className="stat" key={stat.label}>
              <div className="stat-num">
                {stat.num}
                {stat.suffix ? <sup>{stat.suffix}</sup> : null}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section> */}

      <section className="about-story" id="story">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow">Our Story</span>
            <h2>
              왜 <span className="em">교회앱모아</span>인가.
            </h2>
            <p>
              매주 반복되는 주보 인쇄, 불편한 행정 시스템, 청년 성도와 멀어지는 소통, 분산된 헌금·출석 관리 —
              교회 현장의 문제를 기술로 풀고 싶었습니다. 4주안에 완성되는
              프리미엄 교회 전용 앱을 만들어 성도의 신앙과 교회의 운영을 잇는 가장 단정한
              도구가 되고자 합니다.
            </p>
          </div>
        </div>
      </section>

      <section className="about-values" id="mission">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow">Mission</span>
            <h2>
              우리가 지키는 <span className="em">세 가지</span>.
            </h2>
          </div>
          <div className="values-grid reveal">
            {VALUES.map((item) => (
              <div className="value-item" key={item.num}>
                <div className="value-num">{item.num}</div>
                <div className="value-title">{item.title}</div>
                <p className="value-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="about-history" id="history">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow">History</span>
            <h2>
              함께 걸어온 <span className="em">발자취</span>.
            </h2>
          </div>
          <ul className="history-list reveal">
            {HISTORY.map((item) => (
              <li key={item.year}>
                <span className="history-year">{item.year}</span>
                <div>
                  <div className="history-title">{item.title}</div>
                  <p className="history-desc">{item.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="about-team" id="team">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow">Team</span>
            <h2>
              함께하는 <span className="em">사람들</span>.
            </h2>
            <p>팀원의 절반 이상이 교회에서 봉사 · 사역 경험이 있습니다.</p>
          </div>
          <div className="team-grid reveal">
            {TEAM.map((person) => (
              <div className="team-card" key={person.name}>
                <div className="avatar" data-initial={person.initial} />
                <div className="team-name">{person.name}</div>
                <div className="team-role">{person.role}</div>
                <p className="team-desc">{person.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-partners" id="partners">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow">Partners</span>
            <h2>
              함께하는 <span className="em">교회들</span>.
            </h2>
          </div>
          <div className="partners-grid reveal">
            {PARTNERS.map((name) => (
              <div className="partner-item" key={name}>{name}</div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="final-cta">
        <div className="container final-cta-inner reveal">
          <h2>
            우리 교회의 이야기를,
            <br />
            <span className="em">함께</span> 시작해보세요.
          </h2>
          <p>신청 후, 우리 교회에 딱 맞는 견적을 받아보세요.</p>
          <Link to="/inquiry" className="btn-cream">
            신청하기 &nbsp;→
          </Link>
        </div>
      </section>

      <ScrollToTopButton />
      <Footer />
    </div>
  );
}
